import { observable, runInAction } from 'mobx';
import { CTCDEventReportModel, IEventCampaignServices } from 'services/Main/eventCampaign_services';
import { DataResponse } from 'services/response';

export type EventCampaignStore = {
  //    Báo chi tiết event
  ctEventReport: DataResponse<Array<CTCDEventReportModel>>
};

export interface IEventCampaignPresenter {
  createStore(): EventCampaignStore;
  // Hàm lấy data báo cáo Chiến dịch event
  getDataReportCTCDEvent(store: EventCampaignStore, data: object): Promise<void>

  // export report
  exportReport(data: object): Promise<void>
}

export function createEventCampaignPresenter({ eventCampaignService }: { eventCampaignService: IEventCampaignServices }): IEventCampaignPresenter {
  return {
    createStore: (): EventCampaignStore =>
      observable({
        ctEventReport: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        }
      }),
    // // Hàm lấy data báo cáo Chiến dịch event
    getDataReportCTCDEvent: async (store, dataSearch) => {
      try {
        const result = await eventCampaignService.getDataReportCTCDEvent(dataSearch);
        runInAction(() => {
          store.ctEventReport.data = result.data;
          store.ctEventReport.isSuccess = result.isSuccess;
          store.ctEventReport.message = result.message;
          store.ctEventReport.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // export report
    exportReport: async (data) => {
      try {
        await eventCampaignService.exportReport(data);

      } catch (error) {
        console.log(error);
      }
    },


  };
}
